import './windows.css'
import android from '../../img/windows.png'
export default function Windows(){
    return(
        <div className='windowsbox'>
            <div className='windowsimage'><img src={android} alt='windows' loading='lazy'></img></div>
            <div className='windowsdownload'><a href='http://dl.mahoganyacademy.de/windows/Mahogany.exe'>دانلود</a></div>
        </div>
    )
}